/**
 * VERSIONE LIBRERIA 3
 */
var RenderInputHelped = Render.extend({
    customValue : true,
    type : 'input_helped',
    classData : 'input_helped',
    classTemplate : 'input_helped',
    domainValues : {},

    init: function (key,config) {
        this._super(key,config);
        if (_.has(config,'customValue')) {
            this.customValue = config.customValue;
        }
    },
    _setData : function (jQe) {
        var self = this;
        //_.has

        var el = jQe.find('[data-option_values]');
        var tplData = [];
        for(var k in self.domainValues) {
            tplData.push({value:k,label:self.domainValues[k]});
        }
        $.renderTemplate(el,el,tplData);
        return ;
    },
    _renderEdit : function (jQe) {
        var self = this;
        self._setData(jQe);
        var el = jQe.find('[data-render_control]');
        el.attr("name", self.key);

        if (!self.customValue) {
            el.attr('readonly','true');
            if (_.indexOf(_.keys(self.domainValues),self.value) >= 0)
                el.attr('value',self.value);
        } else {
            el.attr('value',self.value);
        }
    },

    _finalizeEdit : function(){
        var self = this;
        $(self.container).find('[data-option_values]').find('button').click(function() {
            var el = $(self.container).find('[data-render_control]');
            el.attr('value',$(this).data('value'));
            self._emitEvent('change',$(this).data('value'));
        });
    },

    setDomainValues : function (values) {
        var self = this;
        self.data.domainValues = values;
        self._setData(self.config.container);
    },
    setValue : function(value) {
        var self = this;
        $(self.config.container).find('[data-render_control]').val(value);
    }
});
